import type {
  DeviceNotice,
  NotificationEmail,
  NotificationRun,
  NotificationSettings,
  NotificationSettingsList,
  NotificationSnooze,
  PenActivityMonth,
  SettingsPatch,
  SnoozeInput,
} from '../domain/notification';
import { notificationsApi as liveApi } from './live-notifications-api';
import { notificationsApi as mockApi } from './mock-notifications-api';

/**
 * The weekly device summary, backed by leatherback's Notifications service
 * (tidaltech/koi#8361, #8362). Staff only.
 */
export interface NotificationsApi {
  listSettings(): Promise<NotificationSettingsList>;
  /** Rejects with ConflictError when the settings changed since `version`. */
  updateSettings(patch: SettingsPatch): Promise<NotificationSettings>;
  /** Rejects with RunTooSoonError within the summary interval unless force. */
  runDeviceSummary(force?: boolean): Promise<NotificationRun>;
  listRuns(): Promise<NotificationRun[]>;
  /** A run's notices; the latest run when runId is omitted. */
  listNotices(
    runId?: string,
  ): Promise<{ run?: NotificationRun | undefined; notices: DeviceNotice[] }>;
  /** The summary emails a run sent or tried to send. */
  listEmails(runId: string): Promise<NotificationEmail[]>;
  createSnooze(input: SnoozeInput): Promise<NotificationSnooze>;
  listSnoozes(includeExpired?: boolean): Promise<NotificationSnooze[]>;
  deleteSnooze(id: string): Promise<void>;
  /** Which pens each device reported from in a month (YYYY-MM); the current month by default. */
  listPenActivity(month?: string): Promise<PenActivityMonth>;
}

export const notificationsApi: NotificationsApi =
  import.meta.env.VITE_API_MODE === 'live' ? liveApi : mockApi;
